

















































import { Component, Mixins, Prop } from "vue-property-decorator";
import { InOrderLayout } from "../../../layouts";
import { PatientFeatureAccessibleMixin } from "../../../patient/mixins";
import { ModelEditableMixin } from "../../../system/mixins";
import { IRestrictions } from "../EditingDocument";
import { DocumentStructureEditableMixin, DocumentEditInformationEditableMixin } from "../mixins";
import {
  DrawModeSelector,
  FreeInputSelector,
  PageNumberSelector,
  EditScaleSelector,
  CalculationMenu,
  PreviewMenu,
  ExtraPageMenu,
  HisInformationMenu,
  PatientProfileMenu,
  FormatMenu,
  TransparentSelector,
  NaturalTextMenu,
  NoteMenu,
} from "./editMenus";
import DocumentAttributesEditor from "./DocumentAttributesEditor.vue";
import { IHisInformationAccessible } from "../../../../domain/his";

@Component({
  components: {
    DocumentAttributesEditor,
    InOrderLayout,
    DrawModeSelector,
    FreeInputSelector,
    PageNumberSelector,
    EditScaleSelector,
    CalculationMenu,
    PreviewMenu,
    ExtraPageMenu,
    HisInformationMenu,
    PatientProfileMenu,
    FormatMenu,
    TransparentSelector,
    NaturalTextMenu,
    NoteMenu,
  },
})
export default class EditMenuContainer extends Mixins(ModelEditableMixin, DocumentStructureEditableMixin, DocumentEditInformationEditableMixin, PatientFeatureAccessibleMixin) {
  @Prop()
  restrictions: IRestrictions;

  get isDocumentAlreadyInitialized(): boolean {
    return this.isSourceEnable
      && this.editingSource.isAlreadyInitialized;
  }

  get isNaturalTextEnable(): boolean {
    return this.$configuration.behavior.document.editor.naturalText.isEnable;
  }

  get isNoteEnable(): boolean {
    return !this.restrictions
        || !this.restrictions.note
        || !this.restrictions.note.isDisabled;
  }

  @Prop()
  hisInformationAccessor: IHisInformationAccessible;
}
